import {fetchConToken} from '../helpers/fetch'

const WNOMINA_URL = 'wnomina/'

export const enviarWNomina = async (data: any) => {
  const resp = await fetchConToken(`${WNOMINA_URL}send`, data, 'POST')
  return await resp.json()
}
